import {forwardRef} from 'react';
import {BleskIconProps} from '../types';

export const BaseIcon = forwardRef<SVGSVGElement, BleskIconProps>(function BaseIcon(
  {children, viewBox = '0 0 24 24', ...rest},
  ref,
) {
  return (
    <svg {...rest} ref={ref} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      {children}
    </svg>
  );
});
